import {UserAttributes} from '@optimizely/optimizely-sdk'
import {
  getDevicePlatform,
  getDeviceType,
  getIsVioFlutterApp,
  getLocale,
  getUserAgent,
  getUserCountryWithFallback
} from 'modules/meta/selectors'
import {RootState} from 'store'
import utmSources from 'utils/utmSources'

import {getBrandCode} from '@vio/core/src/_web/brand/modules/selectors'
import {DevicePlatform} from '@vio/core/src/_web/utils/userAgent/types'
import {BrandCode} from '@vio/core/src/brand/types'
import {DeviceCategory} from '@vio/core/src/utils/userAgent/types'

export interface ExperimentSegmentationAttributes extends UserAttributes {
  application: string
  pathName: string
  env: string
  brandCode: BrandCode
  deviceCategory: DeviceCategory
  devicePlatform: DevicePlatform
  locale: string
  userCountry: string
  isWebView: boolean
  trafficSource: string
  profile: string
  userAgent: string
}

// Mirrors useSetAudiencePage
const AUDIENCE_PAGE_BY_PATHNAME: Record<string, string> = {
  '/checkout': 'Payment',
  '/confirmation': 'Confirmation'
}

export const getExperimentSegmentationAttributes = (
  state: RootState,
  urlObject: URL
): ExperimentSegmentationAttributes => {
  const {searchParams: queryParams, pathname: pathName} = urlObject
  const page = AUDIENCE_PAGE_BY_PATHNAME[pathName]

  return {
    application: 'checkout',
    env: process.env.NEXT_PUBLIC_ENV || 'production',
    pathName,

    brandCode: getBrandCode(state),
    deviceCategory: getDeviceType(state),
    locale: getLocale(state),
    isWebView: getIsVioFlutterApp(state),
    userCountry: getUserCountryWithFallback(state),
    devicePlatform: getDevicePlatform(state),
    userAgent: getUserAgent(state) ?? '',

    trafficSource: utmSources(queryParams.get('utm_source')),
    profile: queryParams.get('profile') ?? '',
    ...(page ? {page} : {})
  }
}
